import React, { useState, useEffect } from 'react';
import './InstagramFeed.css';

const BEHOLD_FEED_URL = 'https://feeds.behold.so/AH5DkFx49FsAU3Vn5lX3';

const InstagramFeed = ({ limit = 6, columns = 3 }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeed = async () => {
      try {
        const response = await fetch(BEHOLD_FEED_URL);
        if (!response.ok) throw new Error('Failed to fetch feed');
        const data = await response.json();
        setPosts(data.posts?.slice(0, limit) || []);
      } catch (err) {
        console.error('Instagram feed error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFeed();
  }, [limit]);

  if (loading) {
    return (
      <div className="instagram-feed">
        <div className="instagram-feed-grid" style={{ '--columns': columns }}>
          {[...Array(limit)].map((_, i) => (
            <div key={i} className="instagram-post-skeleton" />
          ))}
        </div>
      </div>
    );
  }

  if (error || posts.length === 0) {
    return null;
  }

  return (
    <div className="instagram-feed">
      <div className="instagram-feed-grid" style={{ '--columns': columns }}>
        {posts.map((post) => (
          <a
            key={post.id}
            href={post.permalink}
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-post"
          >
            <img
              src={post.sizes?.medium?.mediaUrl || post.mediaUrl}
              alt={post.prunedCaption?.slice(0, 100) || 'Instagram post'}
              loading="lazy"
            />
            <div className="instagram-post-overlay">
              {post.mediaType === 'VIDEO' && (
                <svg className="instagram-media-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              )}
              {post.mediaType === 'CAROUSEL_ALBUM' && (
                <svg className="instagram-media-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12z"/>
                </svg>
              )}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default InstagramFeed;
